/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type EligibilityCriteriaDtoCriteria =
  (typeof EligibilityCriteriaDtoCriteria)[keyof typeof EligibilityCriteriaDtoCriteria];

export const EligibilityCriteriaDtoCriteria = {
  AGI: 'AGI',
  APP_DATE: 'APP_DATE',
  CEEB: 'CEEB',
  DISTANCE: 'DISTANCE',
  GPA_RAW: 'GPA_RAW',
  PELL: 'PELL',
  SAI: 'SAI',
} as const;
